import { FormikField } from '@ahmdigital/ui';

import constants from '../../../../../../ahm-constants';

type StateFieldProps = {
  label?: string;
};

const StateField = ({ label = 'I live in' }: StateFieldProps) => (
  <FormikField
    inputVariant={['button', 'fullWidth']}
    label={label}
    name="state"
    options={constants.STATE_OPTIONS}
    size="auto"
    type="dropdown"
  />
);

export default StateField;
